/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "lhrqejakjzvxjwhxpynu"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxocnFlamFranp2eGp3aHhweW51Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgyNzQ3NjMsImV4cCI6MjA5Mzg1MDc2M30.rpzuWWnsHV7NK2u92zD6RL-oYjWKZNvopbJ1O7elzCI"